<div class="ui-g-12 ui-md-3 ui-lg-3">
  <form [formGroup]="poeDocumentForm">
    <p-select
      panelStyleClass="notification-banner-programtype-dropdown"
      [options]="poeDocumentList"
      placeholder="--Select Document--"
      optionLabel="documentName"
      formControlName="poeDocument"
      (onChange)="onpoeDocumentSelect()"></p-select>
  </form>
</div>
@if (loading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
@if (documentSelected) {
  <div class="ui-g-12">
    <app-event-review-table
      [eventSearchType]="documentSelected.id"></app-event-review-table>
  </div>
}
